import { COMPONENT_TYPES } from '../../../constants';
import PayLetterSuccess from './PayLetterSuccess';
import PayLetterSuccessEditor from './PayLetterSuccess.editor';
import { registerComponent } from '../registry';

// 레지스트리에 컴포넌트 등록
registerComponent({
  type: COMPONENT_TYPES.PAYLETTER_SUCCESS,
  component: PayLetterSuccess,
  editorComponent: PayLetterSuccessEditor,
  defaultProps: {
    style: {
      width: '100%',
      padding: '40px 0',
      backgroundColor: 'transparent'
    },
    componentProps: {
      className: 'payletter-success-container',
      title: '결제가 완료되었습니다',
      successMessage: 'PayLetter 결제가 성공적으로 처리되었습니다.',
      orderButtonText: '주문 내역 확인',
      continueButtonText: '쇼핑 계속하기',
      redirectToOrderHistory: '/orders',
      redirectToHome: '/'
    }
  },
  category: 'payment',
  icon: '✅',
  name: 'PayLetter 결제 성공'
});

export { default as PayLetterSuccessComponent } from './PayLetterSuccess';
export { default as PayLetterSuccessEditor } from './PayLetterSuccess.editor';
export * from './PayLetterSuccess.types'; 